import React from 'react'
import { Link, Route, Routes } from 'react-router-dom'
import ProfileSelection from './ProfileSelection'
import CompanyProfile from './Business/companyProfile'
import FreelancerProfile from './Freelancer/freelancerProfile'
import IdentityDoc from './Freelancer/IdentityDoc'
import IdentityVerify from './Freelancer/IdentityVerify'
import ShareholderProfile from './Business/shareholderInfor'
import CompanyStructure from './Business/CompanyDescription'
import CompanyDescription from './Business/CompanyDescription'
import DocVerify from './Business/DocVerify'
import UploadDoc from './Business/UploadDoc'
import ChoosePlan from './Freelancer/ChoosePlan'
import ChoosePlanCompany from './Business/ChoosePlan'

const Main = () => {
  return (
    <div className="max-h-[100vh] w-full overflow-hidden">
      <div className="bg-white py-4 px-6 w-full">
        <Link to="/" className='w-fit'>
          <h1 className="ml-2 oxygen-bold text-3xl animate__animated animate__backInLeft animate__slow">paycott.</h1>
        </Link>
      </div>
      <div className="bg-light max-h-[100vh] min-h-[100vh] overflow-y-auto pb-20">
        <Routes>
          <Route path="/" element={<ProfileSelection />} />
          <Route path="/freelancer" element={<FreelancerProfile />} />
          <Route path="/freelancer/identityDon" element={<IdentityDoc />} />
          <Route path="/freelancer/plan" element={<ChoosePlan />} />
          <Route path="/freelancer/identityverify" element={<IdentityVerify />} />

          <Route path="/company" element={<CompanyProfile />} />
          <Route path="/company/shareholder" element={<ShareholderProfile />} />
          <Route path="/company/structure" element={<CompanyStructure />} />
          <Route path="/company/description" element={<CompanyDescription />} />
          <Route path="/company/upload" element={<UploadDoc />} />
          <Route path="/company/verify" element={<DocVerify />} />
          <Route path="/company/plan" element={<ChoosePlanCompany />} />

        </Routes>
      </div>
    </div>
  )
}

export default Main